import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';

export default class Toolbox {
    constructor() {
        // Archive outils

        this.slider();
        this.manageTab();
        this.setupGrid();
        window.addEventListener('resize', this.setupGrid);
    }

    slider() {
        const container = document.querySelector('.header .tab');
        if (container) {
            tns({
                container: container,
                items: 1,
                slideBy: 1,
                autoplay: false,
                gutter: 30,
                loop: false,
                mouseDrag: true,
                nav: false,
                speed: 650,
                controlsText: ['<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54"><g fill="none" stroke="#262626" stroke-width="3"><circle cx="27" cy="27" r="27" stroke="none"/><circle cx="27" cy="27" r="25.5" fill="none"/></g><g transform="translate(26.308 39.146) rotate(-135)"><path d="M18.154,0,0,18.154" transform="translate(0 0)" fill="none" stroke="#262626" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/><path d="M7.771,7.771H0V0" transform="translate(0 10.383)" fill="none" stroke="#262626" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></g></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54"><g fill="none" stroke="#262626" stroke-width="3"><circle cx="27" cy="27" r="27" stroke="none"/><circle cx="27" cy="27" r="25.5" fill="none"/></g><g transform="translate(26.308 39.146) rotate(-135)"><path d="M18.154,0,0,18.154" transform="translate(0 0)" fill="none" stroke="#262626" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/><path d="M7.771,7.771H0V0" transform="translate(0 10.383)" fill="none" stroke="#262626" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></g></svg>'],
                responsive: {
                    768: {
                        items: 2,
                    },
                    1024: {
                        items: 4,
                    }
                }
            });
        }
    }

    manageTab() {
        const btns = document.querySelectorAll('.tab__item');
        if(btns.length > 0) {
            btns.forEach((btn) => {
                btn.addEventListener('click', () => {
                    if(!btn.classList.contains('tab__item--selected')) {
                        if(document.querySelector('.tab__item--selected')) {
                            document.querySelector('.tab__item--selected').classList.remove('tab__item--selected');
                        }
                        if(document.querySelector('.tab__element--visible')) {
                            document.querySelector('.tab__element--visible').classList.remove('tab__element--visible');
                        }
                        document.querySelector(`.tab__container .tab__element[data-id="${btn.dataset.id}"]`).classList.add('tab__element--visible');
                        btn.classList.add('tab__item--selected');
                        this.setupGrid();
                    }
                });
            });
        }
    }

    grid(item){
        const grid = document.querySelector('.tab__container .tab__element');
        const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
        const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
        const rowSpan = Math.ceil((item.querySelector('.tab__elementContent').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));
        item.style.gridRowEnd = 'span '+rowSpan;
    }

    setupGrid(){
        this.allItems = document.querySelectorAll('.tab__elementItem');
        for(let x = 0; x < this.allItems.length; x++){
          this.grid( this.allItems[x] );
        }
    }

    resizeInstance(instance){
        const item = instance.elements[0];
        this.grid(item);
    }
}